import { render, staticRenderFns } from "./DocHubVersionText.vue?vue&type=template&id=437cc2ed&scoped=true"
import script from "./DocHubVersionText.vue?vue&type=script&lang=js"
export * from "./DocHubVersionText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437cc2ed",
  null
  
)

export default component.exports